import { IGICard, IGIDef, IGIPartner } from "./genericInsuranceInterface";
import logo1 from "../../../assets/images/leadPages/logo1.png";
import logo2 from "../../../assets/images/leadPages/logo2.png";
import logo3 from "../../../assets/images/leadPages/logo3.png";
import logo4 from "../../../assets/images/leadPages/logo4.png";

export const types: IGICard[] = [
	{ icon: "home", title: "Home" },
	{ icon: "cyber", title: "Cyber" },
	{ icon: "fire", title: "Fire" },
	{ icon: "crop", title: "Crop" },
	{ icon: "marine", title: "Marine" },
	{ icon: "commercial", title: "Commercial" }
];

export const insuranceDef: IGIDef[] = [
	{
		title: "Life Insurance",
		body:
			"A deal between the policyholder and the insurance company where a pre-defined amount is paid to the policyholder or his/her nominee after a specific period or upon death as the case may be. For this, the policyholder needs to pay premium to the insurance company."
	},
	{
		title: "Health insurance",
		body:
			"Financial backup in case of a health contingency. Apart from covering hospitalisation costs, it also covers cost of medicines and doctors’ consultation fees, among others. "
	},
	{
		title: "Motor insurance",
		body: "Financial protection to the owner of the vehicle against losses and damages of one’s own vehicle or of any third-party."
	},
	{
		title: "Travel insurance",
		body:
			"Financially compensates you for any exigencies arising during your travel such as flight cancellation, loss of baggage, theft of important documents, etc."
	}
];

export const benefits: IGICard[] = [
	{
		icon: "fp",
		title: "Financial Protection",
		body:
			"Gives you and your family financial protection in the event of untoward incidents. It compensates for the financial losses incurred due to death of the family’s chief breadwinner or damages suffered to your assets (vehicle, home, etc)."
	},
	{
		icon: "tax",
		title: "Tax Benefits",
		body:
			"Insurance premiums paid towards insurance qualify for tax exemption under different sections of the Income Tax Act, 1961, under the old tax regime. While life insurance premiums are eligible for deduction under section 80C, health insurance premiums are tax exempt under section 80D."
	},
	{
		icon: "goals",
		title: "Keeps Essential Goals on Track",
		body:
			"Insurance helps keep essential goals on track and ensures they don’t go haywire in case of mishaps and untoward incidents. It also ensures your family maintains the same standard of living even in your absence."
	},
	{
		icon: "accumulate",
		title: "Accumulate Wealth",
		body:
			"Insurance policies such as endowment plans and unit-linked insurance plans help save and invest to accumulate a corpus for various critical life goals such as children’s higher education, their marriage and your retirement."
	},
	{
		icon: "loan",
		title: "Avail Loan",
		body:
			"Insurance plans that have a surrender value can be used as collateral for availing loans. You can pledge an endowment plan or money back policy to avail loan to make up for the shortfall in funds, if required."
	},
	{
		icon: "peace",
		title: "Peace of Mind",
		body:
			"Insurance gives you peace of mind, as you know you will be adequately compensated for any loss —life or property — at any stage of life."
	}
];

export const cards: IGICard[] = [
	{
		icon: "coverage",
		title: "Coverage Required",
		body:
			"As a thumb rule, the coverage amount in life insurance must be 10 to 15 times of your annual income. Factor in your current expenses, loans and inflation, among others."
	},
	{
		icon: "claims",
		title: "Claims Settlement Ratio",
		body:
			"This ratio represents the number of claims settled by the insurer against claims received. Expressed in percentage, the higher the ratio, the better it is."
	},
	{
		icon: "premiums",
		title: "Applicable Premiums",
		body:
			"Know the premiums you need to pay towards your insurance policy. Policies with an investment component command a higher premium than those without it."
	}
];

export const partners: IGIPartner[] = [
	{ img: logo1, title: "Edelweiss General<br/>Insurance Company Ltd", tag: "General Insurance" },
	{ img: logo2, title: "Star Health & Allied<br/>Insurance Co Ltd", tag: "Health Insurance" },
	{ img: logo3, title: "Edelweiss Life <br/>Insurance Company Ltd", tag: "Life Insurance" },
	{ img: logo4, title: "HDFC Life Insurance<br/>Company Ltd", tag: "Life Insurance" }
];
